module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Epigraph"
    }
  }, [_c('blockquote', {
    staticClass: "epigraph1"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('span', {
    attrs: {
      "aria-label": "page vi",
      "id": "page_vi",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page vii",
      "id": "page_vii",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The only true voyage, the only bath in the Fountain of Youth, would be not to visit strange lands but to possess other eyes, to see the universe through the eyes of another, of a hundred others, to see the hundred universes that each of them sees, that each of them is.")])])]), _vm._v(" "), _c('p', {
    staticClass: "epir"
  }, [_vm._v("—Marcel Proust")]), _vm._v(" "), _c('p', {
    staticClass: "epi1"
  }, [_vm._v("Los Angeles is a microcosm of the United States. If LA falls, the country falls.")]), _vm._v(" "), _c('p', {
    staticClass: "epir"
  }, [_vm._v("—Ice-T")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef7874a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781982156732/xhtml/epigraph.vue
// module id = 69
// module chunks = 0